import { Plugins, Context } from '@leverege/plugin';
import { R } from '@leverege/value-resolver';
import { Card } from '@leverege/ui-dashboard';
import DataViewerCardModel from "./DataViewerCardModel.js";
import DataViewerModel from "../DataViewerModel.js";
function supportsObjectType(card, objectType) {
  if (card.objectType == null) {
    return true;
  }
  if (typeof card.objectType === 'string') {
    return card.objectType === objectType;
  }
  if (Array.isArray(card.objectType)) {
    return card.objectType.includes(objectType);
  }
  if (typeof card.objectType === 'function') {
    return card.objectType(objectType);
  }
  return false;
}
function getCardsFor(type, props, dc) {
  const objectType = dc.objectType || props?.objectType || props?.relationship?.objectType;
  const filter = card => {
    if (card.isInternal === true) {
      return false;
    }
    if (card.matches) {
      return Context.isMatch(props, card);
    }
    if (supportsObjectType(card, objectType)) {
      if (typeof card.handles === 'function') {
        return card.handles(props, dc);
      }
      return true;
    }
    return false;
  };
  return Plugins.get(type, filter);
  // return Plugins.createView( type, { name : objectType, filter } ).get()
}

// molten.addPlugin( 'DashboardItem', {
//   type : DataCard.TYPE,
//   model : DataCard,
//   viewer : DataCardViewer,
//   menuEditor : createMenuEditor( DataCard ),
//   name : 'Data Card',
//   icon : 'fa fa-table'
// } )

function getCardCreators(props, dc) {
  const cards = getCardsFor('DashboardItem', props, dc);
  return cards.map(card => {
    const dco = {};
    return {
      name: card.name,
      icon: card.icon,
      create: (v, dc) => {
        const content = card.model.create(v, dc);
        return {
          ...Card.create(content, dc),
          ...dco
        };
      },
      isCard: true,
      isLayout: false
    };
  });
}

/**
 * This will return an array of { name, create } objects that are used
 * to present the user with a choice of Card to add to the dashboard.
 * 
 * It will create one for any DataViewer that has been marked with a card
 * location, and any CardModel in the given plugins
 */
function getDataViewerCreators(props, dc) {
  const {
    dataViewers
  } = props;
  const arr = dataViewers.getFor('card');
  return arr.map(dataViewer => {
    return {
      name: dataViewer.name,
      create: (p, dc) => {
        const dco = R(dataViewer.getDefaultCardOptions, props, dc);
        const dcco = R(dataViewer.getDefaultCardContentOptions, props, dc);
        const content = {
          ...DataViewerCardModel.create(DataViewerModel.create(dataViewer.type, dataViewer?.createSettings?.(props))),
          ...dcco
        };
        const card = {
          ...Card.create(content, dc),
          ...dco
        };
        return card;
      },
      isCard: true,
      isLayout: false
    };
  });
}
function getCreators(props, dc) {
  return [...getDataViewerCreators(props, dc), ...getCardCreators(props, dc)];
}
export default getCreators;